module.exports = __webpack_public_path__ + "img/2-5.fa14a8a9.png";